import { CommonStrings } from "../../../../../common/classes/CommonStrings";
import { SMSRouteDefs } from "../../../routing/SMSRouteDefs";

export class AbfertigungsrefundierungRouteDefs {
  public static FEATURE_PATH = "abfertigungsrefundierung";
  public static PARAM_ID = "Id";

  public static LIST_PATH = `${CommonStrings.KW_LIST}`;
  public static EXPORT_PATH = `export`;
  public static FKT_LIST_PATH = `home`;
  public static CREATE_PATH = `${CommonStrings.KW_CREATE}`;
  public static UPDATE_PATH = `:${this.PARAM_ID}`;
  public static APPROVE_PATH = `approve`;
  public static KORRIGIEREN_LIST_PATH = `korrigieren`;
  public static KORRIGIEREN_PATH = `korrigieren/${this.UPDATE_PATH}`;
  public static REPORT_PATH = `report/:year/:quartals`;
  public static REPORT_STABSTELLE_PATH = `report/:year/:quartals/:behinderung/:ibBetriebe`;
  public static VERVOLLSTAENDIGEN_PATH = `vervollstaendigen`;
  public static VERVOLLSTAENDIGEN_ABZEICHNEN_PATH = `vervollstaendigen/abzeichnen`;
  public static REPORT_MITTELDOTIERUNG_PATH = `mitteldotierung/:year/:quartals`;
  public static EXPORT_MITTELDOTIERUNG_PATH = `mitteldotierung`;
  public static MITTELDOTIERUNG_MITTEILEN_PATH = `mitteldotierung/mitteilen`;
  public static MITTELDOTIERUNG_MITTEILEN_SINGLE_PATH = `mitteldotierung/mitteilen/:smsId`;
  public static KORRIGIEREN_BMSGPK_PATH = `korrigierenbmsgpk`;
  public static VERSIONEN_PATH = `v/:versionEntityId/versionen`;
  public static LATEST_VERSIONEN_PATH = `v/latest-versionen`;
  public static AUFROLLUNG_PATH = `aufrollung`;
  public static AUFROLLUNG_PERSON_PATH = `aufrollung/:${this.PARAM_ID}`;

  public static BASE_PATH = `${SMSRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;
  public static LIST_FQ_PATH = `${this.BASE_PATH}/${this.LIST_PATH}`;
  public static EXPORT_FQ_PATH = `${this.BASE_PATH}/${this.EXPORT_PATH}`;
  public static FKT_LIST_FQ_PATH = `${this.BASE_PATH}/${this.FKT_LIST_PATH}`;
  public static CREATE_FQ_PATH = `${this.BASE_PATH}/${this.CREATE_PATH}`;
  public static UPDATE_FQ_PATH = `${this.BASE_PATH}/${this.UPDATE_PATH}`;
  public static APPROVE_FQ_PATH = `${this.BASE_PATH}/${this.APPROVE_PATH}`;
  public static KORRIGIEREN_LIST_FQ_PATH = `${this.BASE_PATH}/${this.KORRIGIEREN_LIST_PATH}`;
  public static KORRIGIEREN_FQ_PATH = `${this.BASE_PATH}/${this.KORRIGIEREN_PATH}`;
  public static REPORT_FQ_PATH = `${this.BASE_PATH}/${this.REPORT_PATH}`;
  public static REPORT_STABSTELLE_FQ_PATH = `${this.BASE_PATH}/${this.REPORT_STABSTELLE_PATH}`;
  public static Vervollstaendigen_FQ_PATH = `${this.BASE_PATH}/${this.VERVOLLSTAENDIGEN_PATH}`;
  public static Vervollstaendigen_Abzeichnen_FQ_PATH = `${this.BASE_PATH}/${this.VERVOLLSTAENDIGEN_ABZEICHNEN_PATH}`;

  public static REPORT_MITTELDOTIERUNG_FQ_PATH = `${this.BASE_PATH}/${this.REPORT_MITTELDOTIERUNG_PATH}`;
  public static EXPORT_MITTELDOTIERUNG_FQ_PATH = `${this.BASE_PATH}/${this.EXPORT_MITTELDOTIERUNG_PATH}`;
  public static MITTELDOTIERUNG_MITTEILEN_FQ_PATH = `${this.BASE_PATH}/${this.MITTELDOTIERUNG_MITTEILEN_PATH}`;
  public static MITTELDOTIERUNG_MITTEILEN_SINGLE_FQ_PATH = `${this.BASE_PATH}/${this.MITTELDOTIERUNG_MITTEILEN_SINGLE_PATH}`;
  public static KORRIGIEREN_BMSGPK_FQ_PATH = `${this.BASE_PATH}/${this.KORRIGIEREN_BMSGPK_PATH}`;
  public static VERSIONEN_FQ_PATH = `${this.BASE_PATH}/${this.VERSIONEN_PATH}`;
  public static LATEST_VERSIONEN_FQ_PATH = `${this.BASE_PATH}/${this.LATEST_VERSIONEN_PATH}`;
  public static AUFROLLUNG_FQ_PATH = `${this.BASE_PATH}/${this.AUFROLLUNG_PATH}`;
  public static AUFROLLUNG_PERSON_FQ_PATH = `${this.BASE_PATH}/${this.AUFROLLUNG_PERSON_PATH}`;

  public static FRISTERSTRECKUNG_CREATE_PATH = `f/fristerstreckung-create`;
  public static FRISTERSTRECKUNG_LIST_PATH = `f/fristerstreckung-list`;
  public static FRISTERSTRECKUNG_CREATE_FQ_PATH = `${this.BASE_PATH}/${this.FRISTERSTRECKUNG_CREATE_PATH}`;
  public static FRISTERSTRECKUNG_LIST_FQ_PATH = `${this.BASE_PATH}/${this.FRISTERSTRECKUNG_LIST_PATH}`;
  public static FRISTERSTRECKUNG_KORREKTUR_PATH = `fristerstreckung-korrektur/:${this.PARAM_ID}`;
  public static FRISTERSTRECKUNG_KORREKTUR_FQ_PATH = `${this.BASE_PATH}/${this.FEATURE_PATH}/fristerstreckung-korrektur/:${this.PARAM_ID}`;

  public static getFQRList = () => this.LIST_FQ_PATH;
  public static getFQRExport = () => this.EXPORT_FQ_PATH;
  public static getFQRFKTList = () => this.FKT_LIST_FQ_PATH;
  public static getFQRCreate = () => this.CREATE_FQ_PATH;
  public static getFQRUpdate = (id: string) => this.UPDATE_FQ_PATH.replace(this.UPDATE_PATH, id);
  public static getFQRApprove = () => this.APPROVE_FQ_PATH;
  public static getFQRKorrigierenList = () => this.KORRIGIEREN_LIST_FQ_PATH;
  public static getFQRKorrigieren = (id: string) => this.KORRIGIEREN_FQ_PATH.replace(this.UPDATE_PATH, id);
  public static getFQRReport = (year: string, quartals: string[], behinderung: string, ibBetriebe: string) =>
    this.REPORT_STABSTELLE_FQ_PATH.replace(":year", year)
      .replace(":quartals", quartals.join(","))
      .replace(":behinderung", behinderung)
      .replace(":ibBetriebe", ibBetriebe);
  public static getFQRVervollstaendigen = () => this.Vervollstaendigen_FQ_PATH;
  public static getFQRVervollstaendigenAbzeichnen = () => this.Vervollstaendigen_Abzeichnen_FQ_PATH;
  public static getFQRMitteldotierungExport = () => this.EXPORT_MITTELDOTIERUNG_FQ_PATH;
  public static getFQRMitteldotierungReport = (year: string, quartals: string[]) =>
    this.REPORT_MITTELDOTIERUNG_FQ_PATH.replace(":year", year).replace(":quartals", quartals.join(","));

  public static getFQRMitteldotierungMitteilen = () => this.MITTELDOTIERUNG_MITTEILEN_FQ_PATH;

  public static getFQRMitteldotierungMitteilenSingle = (smsId: string) =>
    this.MITTELDOTIERUNG_MITTEILEN_SINGLE_FQ_PATH.replace(":smsId", smsId);

  public static getFQRKorrigierenBmsgpk = () => this.KORRIGIEREN_BMSGPK_FQ_PATH;

  public static getFQRVersionenAnzeigen = () => this.LATEST_VERSIONEN_FQ_PATH;
  public static getFQRAufrollung = () => this.AUFROLLUNG_FQ_PATH;
  public static getAufrollung = (id: string) => this.AUFROLLUNG_PERSON_FQ_PATH.replace(`:${this.PARAM_ID}`, id);

  public static getVersionen = (versionEntityId: string) =>
    this.VERSIONEN_FQ_PATH.replaceAll(":versionEntityId", versionEntityId);

  public static getLatestVersionen = () => this.LATEST_VERSIONEN_FQ_PATH;

  public static getFristerstreckungCreate = () => this.FRISTERSTRECKUNG_CREATE_FQ_PATH;

  public static getFristerstreckungList = () => this.FRISTERSTRECKUNG_LIST_FQ_PATH;

  public static getFristerstreckungKorrektur = (id: string) =>
    this.FRISTERSTRECKUNG_KORREKTUR_FQ_PATH.replace(`:${this.PARAM_ID}`, id);
}
